// @ts-nocheck
import useActiveWeb3React from "hooks/useActiveWeb3React";
import useDoubleDownClub from "hooks/useDoubleDownClub";
import { useEffect, useMemo, useState } from "react";
import { gql, useQuery } from "@apollo/client";
import useInterval from '../../lib/hooks/useInterval'
import { CAPITAL_TYPE } from "./enums";
import DDCListItem from "./listitem";
import { SupportedChainId } from "constants/chains";

const DEPOSIT_HISTORY_QUERY = gql`
  query DepositDDCHistories($owner: String, $status: Boolean) {
    depositDDCHistories(where: {owner: $owner, active: $status}) {
      tokenId
      owner
    }
  }
`

const DELEGATE_HISTORY_QUERY = gql`
  query DelegateDDCHistories($owner: String) {
    delegateDDCHistories(where: {from: $owner, amount_gt: 0}) {
      from
      to
      amount
    }
  }
`

const assetAddr = {
  [SupportedChainId.MAINNET]: '0x874069Fa1Eb16D44d622F2e0Ca25eeA172369bC1',
  [SupportedChainId.GOERLI]: '',
  [SupportedChainId.CELO]: '',
  [SupportedChainId.ALFAJORES]: '0x874069Fa1Eb16D44d622F2e0Ca25eeA172369bC1',
  [SupportedChainId.AURORA]: '',
  [SupportedChainId.AURORA_TEST]: '',
  [SupportedChainId.KOVAN]: '',
  [SupportedChainId.POLYGON]: '',
  [SupportedChainId.POLYGON_MUMBAI]: '',
  [SupportedChainId.ARBITRUM_ONE]: '',
  [SupportedChainId.ARBITRUM_RINKEBY]: '',
  [SupportedChainId.OPTIMISM]: '',
  [SupportedChainId.OPTIMISTIC_KOVAN]: '',
}

export default function DDCPosition() {
  const [activeKey, setActiveKey] = useState<CAPITAL_TYPE | null>(null)
  const { tokenIds, balance } = useDoubleDownClub();
  const { account, chainId } = useActiveWeb3React();
  const [tokenAddr, setTokenAddr] = useState(assetAddr[1]);

  const { data: depositResp, refetch } = useQuery(DEPOSIT_HISTORY_QUERY, {
    variables: { owner: account?.toLowerCase(), status: true },
  });
  const { data: delegateResp, refetch: refetchDelegate } = useQuery(DELEGATE_HISTORY_QUERY, {
    variables: { owner: account?.toLowerCase() },
  });

  useEffect(() => {
    if(chainId) {
      setTokenAddr(assetAddr[chainId]);
    }
  }, [chainId])

  useInterval(() => refetch({ owner: account?.toLowerCase(), status: true }), 2000)
  useInterval(() => refetchDelegate({ owner: account?.toLowerCase() }), 2000)

  const depositData = useMemo(() => depositResp?.depositDDCHistories ?? [], [depositResp])
  const delegateData = useMemo(() => delegateResp?.delegateDDCHistories ?? [], [delegateResp])
  const withdrawItems = useMemo(() => depositData?.map((nftItem: any) => {
    return nftItem.tokenId;
  }) , [depositData])

  const delegateCount = delegateData.reduce((total, obj) => {
    console.log(obj);
    return parseInt(obj.amount) + total;
  }, 0);

  const positions = [
    { id: 0, type: CAPITAL_TYPE.DEPOSIT, text: 'Deposit', asset: tokenAddr, amount: parseInt(balance.toString()), tokenIds },
    { id: 1, type: CAPITAL_TYPE.WITHDRAW, text: 'Withdraw', asset: tokenAddr, amount: depositData.length - delegateCount, tokenIds: withdrawItems},
    { id: 2, type: CAPITAL_TYPE.DELEGATE, text: 'Delegate', asset: tokenAddr, amount: depositData.length - delegateCount, tokenIds: []},
    { id: 3, type: CAPITAL_TYPE.UNDELEGATE, text: 'Undelegate', asset: tokenAddr, amount: delegateCount, tokenIds: delegateData}
  ]

  return (
    <>
      {positions.map((p, index) => {
          return <DDCListItem
            setActiveKey={(value) => setActiveKey(value)}
            activeKey={activeKey}
            key={p.id.toString()}
            index={index}
            positionDetails={p}
          />
      })}
    </>
  )
}
